import { useContext } from 'react';

import { enableExperimentFeatures } from '@/config/experiment-feature-toggles';
import { FeatureToggleContext } from '@/contexts/feature-toggle';
import { useAbTastyTests } from '@/lib/ab-tasty/use-ab-tasty-tests';
import { propOf } from '@/lib/utils';

export const useFeatureToggle = () => {
  const { enabledFeatures } = useContext(FeatureToggleContext);
  if (!enabledFeatures['ab-tasty']) {
    return { isEnabled: propOf(enabledFeatures) };
  }

  // eslint-disable-next-line react-hooks/rules-of-hooks -- Condition is project-wide
  const abTastyTests = useAbTastyTests();

  const experimentFeatures = enableExperimentFeatures(
    enabledFeatures,
    abTastyTests
  );

  return { isEnabled: propOf(experimentFeatures) };
};
